import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { ChangeEvent, useEffect, useState } from 'react';
import { useDebounce } from '../../../../../hooks/useDebounce';
import { axiosCallHandler } from '../../../../../infra/axiosHelper';
import { StyledTextField } from './styles';

const Search = ({
  userList,
  setUserList,
  selectedUser,
  setSelectedUser,
  isSearchInput
}: any) => {
  const [searchTerm, setSearchTerm] = useState({ text: '', version: 1 });
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
    if(e.target.value === ''){
      axiosCallHandler({ 
        method: 'GET',
        url: `/users`
      }).then(res => setUserList(res?.content)).catch(err => console.log(err))
    }

    setSearchTerm({ text: e.target.value, version: Math.random() });
  }

  useEffect(() => {
    if (debouncedSearchTerm.text.replace(/ /g, '') !== '') {
      axiosCallHandler({
        method: 'GET',
        url: `/users?q=${debouncedSearchTerm.text}`,
      }).then((res) => setUserList(res?.content)).catch(err => console.log(err));
    }
  }, [debouncedSearchTerm, setUserList]);

  if(isSearchInput) {
    return <StyledTextField 
      label="Pesquisar"
      variant="outlined"
      value={searchTerm.text}
      onInput={handleInput}
    />
  }

  return (
    <Autocomplete
      autoComplete={false}
      clearOnBlur={false}
      options={userList}
      value={selectedUser}
      onInput={handleInput}
      onChange={(event: any, newValue: any) => {
        setSelectedUser(newValue);
      }}
      getOptionLabel={(users) => users.username || ''}
      renderInput={(params) => (
        <TextField {...params} label="Pesquisar" variant="outlined" />
      )}
    />
  );
};

export default Search;
